import React from 'react';
import { withInject } from '@piwikpro/platform';
import {
  AutoSavedTagsInputControl,
  Card,
  withTranslation,
} from '@piwikpro/ui-components';
import { FormValidator } from '@piwikpro/form-crate';
import { TrackerSettings, TrackerSettingsAttributes, TrackerSettingsResponse } from '../../../TrackerSettings';

export interface CampaignMediumParamsProps {
  settings: TrackerSettingsResponse
  trackerSettings: TrackerSettings
  validation: FormValidator
  t: (key: string) => string
}

export class CampaignMediumParams extends React.Component<CampaignMediumParamsProps> {
  constructor(props: CampaignMediumParamsProps) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(values: Partial<TrackerSettingsAttributes>, {
    setErrors,
    setSubmitting,
    setFieldValue,
  }: any) {
    const { trackerSettings, settings } = this.props;

    try {
      await trackerSettings.updateSettings(values);
    } catch (err: any) {
      setErrors(err.errors);
      setFieldValue(
        Object.keys(values)[0],
        (settings.attributes as any)[Object.keys(values)[0]],
        false,
      );
    }

    setSubmitting(false);
  }

  render() {
    const { settings, t, validation } = this.props;

    return (
      <Card.Section>
        <AutoSavedTagsInputControl
          id="tracker-settings-campaign-medium-params"
          label={t('apps.details.settings.campaignMediumParams.title')}
          info={t('components:tagsInput.placeholder.default')}
          name="campaign_medium_params"
          initialValue={settings.attributes.campaign_medium_params}
          validationSchema={validation.createValidationSchema(
            (validators: any) => ({
              campaign_medium_params: validators.trackerSettings.campaignMediumParams,
            }),
          )}
          onSubmit={this.handleSubmit}
        />
      </Card.Section>
    );
  }
}

export default withInject({
  trackerSettings: 'TrackerSettingsCrate.tracker',
  validation: 'FormCrate.validation',
})(withTranslation(['administration'])(CampaignMediumParams as any));
